import * as angular from 'angular';

angular.module('naut').directive('imageonload', function () {
    return {
        restrict: 'A',
        link: function (scope: ng.IScope, element: JQLite, attrs: any) {
            element.bind('load', function () {
                // call the function that was passed
                if (attrs.imageonload) {
                    scope.$apply(attrs.imageonload);
                }
            });
        }
    };
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/campaigns/directives/image-onload.directive.ts